import React from "react";
import {Redirect, useLocation} from 'react-router-dom';
/* import { Link, useLocation } from "react-router-dom"; */

const RedirectLogin = (props) => {
  //const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
    {/* <Navigate to="/login" /> */}
    {/* {navigate('/login')} */}
    <Redirect to="/login"  state={{ from: location }} />
    {/* <Link to="/login" state={{ from: location }} /> */}

    </>
  )
}

export default RedirectLogin